import { useMemo } from 'react';
import { useLocalization } from '../../context/Localization/localization';
import { versionNumber } from '../../helpers/version';

export const VersionInfo = () => {
    const Localization = useLocalization();
    const version: string = useMemo(() => versionNumber(), []);

    return <p>{Localization.formatString(Localization.ReleaseVersionNumber, version)}</p>;
};
